export default __webpack_public_path__ + "static/insta-icon-469cb83ec463191dffdf547f7c748dc3.png";